import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Spinner, SpinnerTypes } from '..';
import { classes } from './Spinner.visual.st.css';

visualize('Spinner', () => {
  story('simple', () => {
    snap('default props', <Spinner isStatic />);
    snap('slim props', <Spinner isStatic type={SpinnerTypes.slim} />);
  });

  story('Path Color', () => {
    snap('red spinner', <Spinner isStatic className={classes.redSpinner} />);
    snap('green spinner wst', <Spinner isStatic className={classes.greenWst} />);
  });

  story('Diameter deprecated prop', () => {
    snap('diameter=100', <Spinner isStatic diameter={100} />);
  });

  story('Diameter CSS var', () => {
    snap(
      'largeDiameter',
      <Spinner isStatic className={classes.largeDiameter} />,
    );
  });
  story('Line width CSS clamp', () => {
    snap(
      'min line width 1px',
      <Spinner isStatic className={classes.bottomClamp} />,
    );
    snap(
      'max line width 10px',
      <Spinner isStatic className={classes.upperClamp} />,
    );
  });
  story('Centered', () => {
    snap(
      'isCentered largeDiameter',
      <Spinner isStatic isCentered className={classes.largeDiameter} />,
    );
  });
});
